import { useState, useEffect } from "react"

function createScript(src) {
  const el = document.createElement("script")
  el.defer = true
  el.src = src
  return el
}

/**
 * Hook to run code that is dependent upon a third-party script
 *
 * @note Third-party script tag loading is idempotent - as in once it is loaded it won't load again.
 * @param {string} src The script tag URL
 * @param {Function} onLoad The function to execute when the script tag is loaded. If the script tag is already loaded then this function will call immediately.
 * @returns {boolean} Whether the script has been loaded or not
 */
const useScript = (src, onLoad) => {
  const [loaded, setLoaded] = useState(
    typeof document !== "undefined" &&
      document.querySelectorAll(`script[src="${src}"]`).length > 0
  )

  useEffect(() => {
    if (typeof document !== "undefined") {
      if (!loaded) {
        const el = createScript(src)
        el.onload = () => {
          setLoaded(true)
        }
        document.body.append(el)
      } else if (onLoad) {
        onLoad()
      }
    }
  }, [loaded, onLoad, src])

  return loaded
}

export default useScript
